export default __webpack_public_path__ + "static/media/A Nostalgic Sound.726f07d3.png";